var _rect, _path, _path2, _rect2, _rect3, _rect4, _rect5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhatCanYouDo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 65.5229,
    height: 65.5229,
    rx: 32.7615,
    fill: "#F9EBE9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3168 13.1591L38.471 29.4467L27.8066 36.3704L20.3168 13.1591Z",
    fill: "#A02524"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8112 53.9681L28.6569 37.6805L39.3213 30.7568L46.8112 53.9681Z",
    fill: "#A02524"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31.791,
    width: 1.94132,
    height: 8.85761,
    fill: "#A02524"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 31.791,
    y: 56.665,
    width: 1.94132,
    height: 8.85761,
    fill: "#A02524"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 33.7319,
    width: 1.94132,
    height: 8.85761,
    transform: "rotate(-90 0 33.7319)",
    fill: "#A02524"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 56.665,
    y: 33.7319,
    width: 1.94132,
    height: 8.85761,
    transform: "rotate(-90 56.665 33.7319)",
    fill: "#A02524"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatCanYouDo);
export default __webpack_public_path__ + "static/media/what_can_you_do.e0ca1bfff63131318f2d8062a66846e0.svg";
export { ForwardRef as ReactComponent };